export class WorkflowApplicationNote {
  id: string;
  workflowApplicationId: string;
  note: string;
  createdOn: Date;
  createdBy: string;
  modifiedOn: Date;
  modifiedOnString?: string;
  modifiedBy: string;
  deletedOn?: Date;
  deletedBy?: string;
  isExternal: boolean;
  isReadByCurrentUser?: boolean;

  constructor(data?: Partial<WorkflowApplicationNote>) {
    if (data) {
      Object.assign(this, data);
      if (data.createdOn) {
        this.createdOn = new Date(data.createdOn);
      }
      if (data.modifiedOn) {
        this.modifiedOn = new Date(data.modifiedOn);
      }
      if (data.deletedOn) {
        this.deletedOn = new Date(data.deletedOn);
      }
    }
  }
}
